import React from "react";
import SettingsSideNav from "../../components/Settings/SettingsSideNav";
import styles from "../../styles/modules/Settings.module.scss";

function SettingsWrapper(props) {
	return (
        <div className={styles.page + " " + props.classes}>
            <h1 className={styles.header}>
                {props.header}
            </h1>
            <div className={styles.columns}>
				<div className={styles.main}>
                    {props.main}
                </div>
                <div className={styles.sidenav}>
                    <SettingsSideNav/>
                </div>
            </div>
        </div>
	);
}
export default SettingsWrapper;
